import { Tabs, Tab, Box } from "@mui/material";
import { useState } from "react";
import OrderDetailsTab from "./OrderDetailsTab";
import BusinessDetailsTab from "./BusinessDetailsTab";
import DriverDetails from "./DriverDetailsTap";
import ReceiverDetailsTab from "./ReceiverDetailsTab";
import OrderLogsTab from "./OrderLogsTab";
import { useRTL } from "hooks/isRTL";
import { useOrderContext } from "contexts/OrderContext";
import LoadingBanner from "Components/shared/LoadingBanner";

/**
 * Displays a tabbed interface for order-related details.
 */
const OrderDetailsTabs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useRTL();
  const { isLoading } = useOrderContext();

  /**
   * Handles the change of the active tab.
   */
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  if (isLoading) {
    return <LoadingBanner isLoading={true} message="Loading..." />;
  }

  return (
    <Box sx={{ width: "100%", marginTop: "2rem", backgroundColor: "white" }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        aria-label="Order Details Tabs"
        variant="fullWidth"
      >
        <Tab label={t("orderDetails")} />
        <Tab label={t("businessDetails")} />
        <Tab label={t("driverDetails")} />
        <Tab label={t("receiverDetails")} />
        <Tab label={t("logs")} />
      </Tabs>

      <Box sx={{ padding: "1rem" }}>
        {activeTab === 0 && <OrderDetailsTab />}
        {activeTab === 1 && <BusinessDetailsTab />}
        {activeTab === 2 && <DriverDetails />}
        {activeTab === 3 && <ReceiverDetailsTab />}
        {activeTab === 4 && <OrderLogsTab />}
      </Box>
    </Box>
  );
};

export default OrderDetailsTabs;
